import { ILeaveContactsFormValue } from './types';

export const DEFAULT_DIALOG_TITLE = 'Оставьте свои контакты';
export const DEFAULT_DIALOG_SUBTITLE = 'Мы поможем вам по любым вопросам';
export const DEFAULT_DIALOG_SUCCESS_MESSAGE = 'Мы свяжемся с вами в ближайшее время';
export const DEFAULT_DIALOG_FAIL_MESSAGE = 'Во время отправки произошла ошибка';

export const FORM_INITIAL_VALUE: ILeaveContactsFormValue = { name: '', phone: '' };

export const FORM_PHONE_PREFIX = '+7';
export const FORM_PHONE_MASK = '(000) 000-00-00';
